export function parseMapCoordinates(value) {
  const matches = String(value || '').match(/[-+]?\d+(?:[.,]\d+)?/g) || [];
  if (matches.length !== 2) {
    return {
      valid: false,
      error: 'Digite latitude e longitude, por exemplo: -19.245730, -44.633450.',
    };
  }

  const lat = Number(matches[0].replace(',', '.'));
  const lng = Number(matches[1].replace(',', '.'));
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) {
    return {
      valid: false,
      error: 'Confira os valores: latitude deve ficar entre -90 e 90 e longitude entre -180 e 180.',
    };
  }

  return {
    valid: true,
    lat: Number(lat.toFixed(6)),
    lng: Number(lng.toFixed(6)),
    normalized: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
  };
}

export function formatMapCoordinates(lat, lng) {
  if (lat === '' || lng === '' || lat == null || lng == null) return '';
  const parsedLat = Number(lat);
  const parsedLng = Number(lng);
  if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) return '';
  return `${parsedLat.toFixed(6)}, ${parsedLng.toFixed(6)}`;
}
